import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=238a61fe&"
import script from "./CommentInput.vue?vue&type=script&lang=js&"
export * from "./CommentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports